import React from 'react';
import './App.css';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Input, Typography } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    borderRadius: '25px',
    background: 'linear-gradient(63deg, rgba(77,190,223,1) 0%, rgba(14,42,81,1) 100%)',
    color: '#ffffff',
    width: '200px'
  },
  stripe: {
    height: 50
  },
  stripeBox: {
   backgroundColor: '#DCDCDC',
   borderRadius: '15px'
  },
  comp: {
   height: '200px'
   },
   textBox: {
     width: '400px'
   }
}));
const {REACT_APP_Stripe_public} = process.env;
function Funding() {
  const classes = useStyles();
  var url = new URL(window.location.href)
  var act = url.searchParams.get("acct");
  var newUser = url.searchParams.get("person");

  
      function AddID() {
        uploadDocument().then(updatePerson);
      };
      function updatePerson(fileId) {
        debug('Updating person...');
        fetch('https://us-central1-onboarding-b9a6e.cloudfunctions.net/app/update-person-file', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            person: newUser,
            account: act,
            file: fileId
          })
        }).then(function(r) {
          return r.json();
        }).then(function(response) {
          debug(JSON.stringify(response, null, 2));
        });
      }
      function uploadDocument() {
    
        var fd = new FormData();
        fd.set('purpose', 'identity_document');
        fd.set('file', document.getElementById('file').files[0]);
        debug('Uploading document...');
        return fetch('https://files.stripe.com/v1/files', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${REACT_APP_Stripe_public}`
          },
          body: fd
        }).then(function(r) {
          return r.json();
        }).then(function(response) {
          debug(JSON.stringify(response, null, 2));
          return response.id;
        });
      }
      function debug(message) {
        var debugMessage = document.getElementById('debug-message');
        console.log('DEBUG: ', message);
        debugMessage.innerText += "\n" + message;
      }
  return (
    <div id="main">
      <div id="checkout">
        <div id="payment-form">
          <br/>
          <center>
             <img src="Identity.gif" className={classes.comp}/>
             <br/>
             <Typography variant='body1' className={classes.textBox}>
             <b>Please submit a valid government ID in order to verify your Identity</b>
             <br/>
             <br/>
                Acceptable documents vary by country, although a passport scan is always acceptable and preferred.
                Scans of both the front and back are usually required for government-issued IDs and driver’s licenses.
                Files need to be JPEGs or PNGs smaller than 10MB. We can’t verify PDFs.
                Files should be in color, be rotated with the image right-side up, and have all information clearly legible.
             </Typography>
             <br/>
                <Input type="file" id="file"/>
          <br/>
            <Button className={classes.submit} id="document-button" onClick={AddID}>Upload</Button>
          </center>
     
        </div>
        <div style={{visibility: 'hidden'}}id="debug-message"></div>
      </div>
    </div>
  );
}

export default Funding;
